import React, { useEffect, useState } from "react"; // ADD useEffect, useState
import { Dashboard } from "../../layout";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  Home,
  Header,
  NotFound,
  NavMenu,
  AddEditProd,
  Products,
  Categories,
  AddEditCat,
  Pos,
  Purchases,
  PurchReturn,
  AddEditPurchReturn,
  ExpsCat,
  Suppliers,
  AddEditSplr,
  Customers,
  AddEditCustomer,
  CustomerAccount,
  CustomerBalanceReport,
  CustomerReport,
  Users,
  AddEditUser,
  Sells,
  StockTransfers,
  AddEditTransfer,
  Inventory,
  AddEditInventory,
  SalaryPayment,
  SalaryHistory,
  EmployeeHistory,
  PayBills,
  StoreReports,
  ProductReport,
  PurchaseReport,
  RegReport,
  ExpenseReport,
  ProdSellVol,
  EmployeeReport,
  TopSelling,
  ReturnProd,
  RefundReport,
  Stores,
  AddEditStore,
  StorePrinters,
  PosSettings,
  DefaultStore,
  AddMultPurch,
} from "../";

import { connect } from "react-redux";
//import { IsEmptyObj } from "../../hooks/Method";
//import { DropLi } from "../../hooks";

import * as actions from "../../api/actions/pos"; // ADD
import { controller, endpoints } from "../../api/actions/api"; // ADD
import { safeOnComplete } from "../../utils/safeOnComplete";

const DashRoute = ({ _authUser, _get }) => { // ADD _get

const [companyName, setCompanyName] = useState(""); // ADD

const role = Number(_authUser?.role);

   // ADD: fetch company name once
   useEffect(() => {
    if (!_get || !_authUser?.id) return;

    const onComplete = safeOnComplete(
      (res) => {
        const name =
          res?.result?.companyName ||
          res?.result?.name;

        if (name) {
          setCompanyName(name);
        }
      },
      (err) => {
        console.error("Company fetch failed:", err);
      }
    );

    _get(
      endpoints.Companies + controller.GetCompanyName,
      actions.ActionType.Data,
      onComplete
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_authUser?.id]);

    // ✅ ADD THIS GUARD HERE (TOP OF COMPONENT)
  if (!_authUser || _authUser.role == null) {
    return <Navigate to="/" replace />;
  }

  // ADD END

  return (
    <Dashboard
      menu={<NavMenu />}
      header={<Header />}
      showNav={role !== 3}
     
      // ADD: replace user full name with company name
      title={companyName || "??"}

      // ADD: optional subtitle (store name removed or left blank)
      subTitle={""}

    >
      <Routes>
        <Route
          path="/"
          element={
            <Navigate
              to={
                Number(role) === 1
                  ? "/dashboard"
                  : Number(role) === 2
                  ? "/sells"
                  : "/pos"
              }
              replace
            />
          }
        />

        <Route
          path="/login"
          element={
            <Navigate
              to={
                Number(role) === 1
                  ? "/dashboard"
                  : Number(role) === 2
                  ? "/sells"
                  : "/pos"
              }
              replace
            />
          }
        />

        <Route path="pos/*" element={<Pos />} />

        <Route path="users/user-form" element={<AddEditUser />} />
        <Route path="users/user-form/:id" element={<AddEditUser />} />    

        {role !== 3 && (
          <>
            <Route path="products" element={<Products />} />
            <Route path="products/product-form/">
              <Route path=":id" element={<AddEditProd />} />
              <Route path="" element={<AddEditProd />} />
            </Route>
            <Route path="categories" element={<Categories />} />
            <Route path="expenses" element={<ExpsCat />} />
            <Route path="categories/cat-form/:id" element={<AddEditCat />} />
            <Route path="purchases" element={<Purchases />} />
            <Route path="purchases/multi-purchase-form">
              <Route path=":id" element={<AddMultPurch />} />
              <Route path="" element={<AddMultPurch />} />
            </Route>
            <Route path="purchases-return" element={<PurchReturn />} />
            <Route path="purchases-return/purchase-return-form">
              <Route path=":id" element={<AddEditPurchReturn />} />
              <Route path="" element={<AddEditPurchReturn />} />
            </Route>

            <Route path="suppliers" element={<Suppliers />} />
            <Route path="suppliers/supplier-form/">
              <Route path=":id" element={<AddEditSplr />} />
              <Route path="" element={<AddEditSplr />} />
            </Route>


            <Route path="customers" element={<Customers />} />
           <Route path="customers/customer-form/">
            <Route path=":id" element={<AddEditCustomer />} />
            <Route path="" element={<AddEditCustomer />} />
          </Route>
           
            <Route
              path="customers/customer-account"
              element={<CustomerAccount />}
            />

            <Route
              path="customers/customer-balance-report"
              element={<CustomerBalanceReport />}
            />

            <Route
              path="customers/customer-report/:customerId"
              element={<CustomerReport />}
            />
            
            <Route path="sells" element={<Sells />} />

            <Route path="stock-transfer" element={<StockTransfers />} />
            <Route path="stock-transfer/stock-transfer-form/">
              <Route path=":id" element={<AddEditTransfer />} />
              <Route path="" element={<AddEditTransfer />} />
            </Route>


            <Route path="inventory" element={<Inventory />} />
            <Route
              path="inventory/inventory-form/:id"
              element={<AddEditInventory />}
            />
          </>
        )}
        {role === 1 && (
          <>
            <Route path="/dashboard" element={<Home />} />
            <Route path="users" element={<Users />} />
            <Route path="salary-payment" element={<SalaryPayment />} />
            <Route path="salary-history" element={<SalaryHistory />} />
            <Route path="employee-history" element={<EmployeeHistory />} />
            <Route path="paybills" element={<PayBills />} />
            <Route path="store-report" element={<StoreReports />} />
            <Route path="product-report" element={<ProductReport />} />
            <Route path="purchase-report" element={<PurchaseReport />} />
            <Route path="register-report" element={<RegReport />} />
            <Route path="expense-report" element={<ExpenseReport />} />
            <Route path="products-sell-volume" element={<ProdSellVol />} />
            <Route path="employee-report" element={<EmployeeReport />} />
            <Route path="top-selling" element={<TopSelling />} />
            <Route path="return" element={<ReturnProd />} />
            <Route path="refund-report" element={<RefundReport />} />
            <Route path="store-settings" element={<Stores />} />
            <Route
              path="store-settings/add-store-form/:id"
              element={<AddEditStore />}
            />
            <Route
              path="store-settings/printers/:storeId"
              element={<StorePrinters />}
            />
            <Route path="pos-settings" element={<PosSettings />} />
            <Route path="default-store" element={<DefaultStore />} />
          </>
        )}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Dashboard>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
});

//const mapActiontoProps = {};

const mapActiontoProps = {
  _get: actions.get, // ✅ REQUIRED
};


export default connect(mapStateToProps, mapActiontoProps)(DashRoute);
